import type {BgColor} from '../../../lib/lvs-foni'
import type {CustomStepProps} from '../../../lib/sign-catalog'
import {FoniBgControls} from '../../foni'

export interface BackgroundStepProps extends CustomStepProps {
    readonly allowBgColors: readonly BgColor[]
    readonly allowStrike: boolean
}

export function BackgroundStep({input, onChange, allowBgColors, allowStrike}: BackgroundStepProps) {
    return (
        <FoniBgControls
            bgColor={input.bgColor}
            onBgColorChange={bgColor => onChange({bgColor})}
            strike={input.strike}
            onStrikeChange={strike => onChange({strike})}
            allowBgColors={allowBgColors}
            showStrike={allowStrike}
        />
    )
}
